import { v4 as uuid } from 'uuid';

const USER_KEY = 'seplag-xbot:user_id';
const SESSION_KEY = 'seplag-xbot:session_id';

export function ensureIdentifiers(): { userId: string; sessionId: string } {
  return { userId: getUserId(), sessionId: getSessionId() };
}

export function getUserId(): string {
  try {
    let id = localStorage.getItem(USER_KEY);
    if (!id) {
      id = uuid();
      localStorage.setItem(USER_KEY, id);
    }
    return id;
  } catch {
    return uuid();
  }
}

export function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = uuid();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return uuid();
  }
}

export function resetSession(): string {
  const fresh = uuid();
  try {
    sessionStorage.setItem(SESSION_KEY, fresh);
  } catch {
    // ignore
  }
  return fresh;
}
